import moment from "moment";
import axios from "axios";
import LineChart from "@/components/Common/LineChart/LineChart";
import _ from "lodash";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  components: { LineChart },
  props: {
    entityType: { type: String, required: true },
    configAction: { type: String, required: true },
    matomoEndpoint: { type: String, required: true },
    matomoTokenAuth: { type: String, required: true },
    matomoSiteId: { type: Number, required: true }
  },
  data() {
    const visitsChartConfig = {
      config: {},
      visitsData: {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: []
          }
        ]
      },
      options: {
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      },
      chartStyle: { height: "300px", position: "relative" }
    };

    return {
      fromDate: moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      menu1: false,
      menu2: false,
      searchQuery: "",
      selectedItem: null,
      selectedApiKey: "",
      items: [],
      totalItems: 0,
      currentPage: 1,
      itemsPerPage: 10,
      chartData: { labels: [], datasets: [] },
      chartOptions: { responsive: true, maintainAspectRatio: false },
      visitsChartConfig,
      selectedResolution: "day",
      resolution: [
        { name: "Täglich", value: "day" },
        { name: "Wöchentlich", value: "week" },
        { name: "Monatlich", value: "month" }
      ],
      inquiryStatistics: null
    };
  },
  computed: {
    computedFromDate() {
      return moment(this.fromDate).format("DD.MM.YYYY");
    },
    computedToDate() {
      return moment(this.toDate).format("DD.MM.YYYY");
    },
    apiKeys() {
      if (this.entityType === "news") {
        return this.$store.state.newsConfig?.apiKeys || [];
      } else if (this.entityType === "poi") {
        return this.$store.state.apiKeys || [];
      } else if (this.entityType === "event") {
        return this.$store.state.eventConfig?.apiKeys || [];
      }
      return [];
    },
    apiKeysArray() {
      return this.apiKeys.map(key => key.apiKey);
    },
    apiKeysMap() {
      return this.apiKeys.reduce((map, key) => {
        map[key.apiKey] = key.description;
        return map;
      }, {});
    },
    currentPrincipal() {
      return this.$store.state?.selectedPrincipal?.id;
    },
    categoryTypes() {
      return this.$store.state?.categoryTypes ?? [];
    },
    hasConferences() {
      if (this.entityType !== "poi") {
        return false;
      }
      return this.categoryTypes.some(
        type =>
          type._id === "68b6a81ce46e77e5da996de5" ||
          type.title.toLowerCase().includes("tagung")
      );
    },
    isNews() {
      return this.entityType === "news";
    }
  },
  watch: {
    fromDate() {
      this.currentPage = 1;
      this.selectedItem = null;
      this.fetchOverviewData();
    },
    toDate() {
      this.currentPage = 1;
      this.selectedItem = null;
      this.fetchOverviewData();
    },
    currentPrincipal() {
      this.currentPage = 1;
      this.selectedItem = null;
      this.fetchOverviewData();
      this.$forceUpdate();
    },
    currentPage() {
      this.selectedItem = null;
      this.fetchOverviewData();
    },
    selectedResolution() {
      this.currentPage = 1;
      this.selectedItem = null;
      this.fetchOverviewData();
    },
    selectedApiKey() {
      this.currentPage = 1;
      this.selectedItem = null;
      this.fetchOverviewData();
    },
    searchQuery: _.debounce(function() {
      this.currentPage = 1;
      this.selectedItem = null;
      this.fetchOverviewData();
    }, 400)
  },
  async mounted() {
    this.currentPage = 1;
    await Promise.all([
      this.fetchOverviewData(),
      this.$store.dispatch("getCategoryTypes")
    ]);
  },
  methods: {
    formatDropdownText(item) {
      return `${item.apiKey} - ${item.description}`;
    },

    normalizeTitle(label) {
      if (!label) return "";
      return String(label)
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    },

    async fetchOverviewData() {
      await this.$store.dispatch(this.configAction);

      if (this.apiKeysArray.length === 0) {
        return; // !important
      }

      const segmentFilter = this.selectedApiKey
        ? `userId==${this.selectedApiKey}`
        : this.apiKeysArray.length > 0
        ? this.apiKeysArray.map(key => `userId==${key}`).join(",")
        : "userId==NO_API_KEY"; // Ensures no data is returned if no valid keys exist

      let baseParams = {
        module: "API",
        method: "Actions.getPageTitles",
        idSite: this.matomoSiteId,
        period: "range",
        date: `${this.fromDate},${this.toDate}`,
        format: "json",
        token_auth: this.matomoTokenAuth,
        segment: segmentFilter,
        showColumns: "label,nb_hits",
        filter_sort_column: "nb_hits",
        filter_sort_order: "desc",
        random: Date.now()
      };

      if (this.searchQuery) {
        baseParams.filter_pattern = this.searchQuery.replace(
          /[.*+?^${}()|[\]\\]/g,
          "\\$&"
        );
        baseParams.filter_column = "label";
      }

      try {
        const response = await axios.get(this.matomoEndpoint + "/index.php", {
          params: {
            ...baseParams,
            filter_limit: this.itemsPerPage,
            filter_offset: (this.currentPage - 1) * this.itemsPerPage
          }
        });

        const items = response.data
          //.filter(item => !this.isUndefinedTitle(item?.label))
          .map(item => ({
            name: item.label,
            visits: item.nb_hits
          }));

        this.items = items;

        if (this.isNews) {
          this.items.forEach((item, i) => {
            this.getNewsLikesByTitle(item.name).then(likes => {
              this.$set(this.items[i], "likes", likes);
            });
          });
        }

        const totalResponse = await axios.get(
          this.matomoEndpoint + "/index.php",
          {
            params: {
              ...baseParams,
              filter_limit: -1,
              showColumns: "label"
            }
          }
        );

        this.totalItems = totalResponse.data.length;

        if (this.hasConferences) {
          this.inquiryStatistics = await this.getConferenceInquiryStatistics();
        }

        if (this.currentPage === 1) {
          baseParams.method = "Actions.get";
          baseParams.period = "day";
          baseParams.period = this.selectedResolution;
          delete baseParams.showColumns;
          const initialChart = await axios.get(
            this.matomoEndpoint + "/index.php",
            {
              params: {
                ...baseParams
              }
            }
          );
          await this.updateChart(initialChart.data, "Alle Aufrufe");
        }
      } catch (error) {
        console.error("Fehler beim Laden der Daten:", error);
      }
    },

    async fetchItemDetails(title) {
      if (this.selectedItem === title) {
        this.selectedItem = null;
        await this.fetchOverviewData();
        return;
      }

      this.selectedItem = title;

      if (this.apiKeysArray.length === 0) {
        return; // !important
      }

      const userSegment = this.selectedApiKey
        ? `userId==${this.selectedApiKey}`
        : this.apiKeysArray.length > 0
        ? this.apiKeysArray.map(key => `userId==${key}`).join(",")
        : "userId==NO_API_KEY"; // Ensures no data is returned if no valid keys exist

      try {
        const response = await axios.get(this.matomoEndpoint + "/index.php", {
          params: {
            module: "API",
            method: "Actions.getPageTitle",
            idSite: this.matomoSiteId,
            period: this.selectedResolution,
            date: `${this.fromDate},${this.toDate}`,
            format: "json",
            token_auth: this.matomoTokenAuth,
            segment: userSegment,
            pageName: title,
            random: Date.now()
          }
        });

        const data = response.data;
        await this.updateChart(
          data,
          `${
            this.selectedResolution === "day"
              ? "Tägliche"
              : this.selectedResolution === "week"
              ? "Wöchentliche"
              : "Monatliche"
          } Aufrufe für: ${title}`
        );
      } catch (error) {
        console.error("Fehler beim Laden der Detaildaten:", error);
      }
    },
    async updateChart(data, title) {
      const isWeekly = Object.keys(data).some(date => date.includes(","));

      const labels = Object.keys(data).map(dateKey => {
        if (isWeekly) {
          const [startDate, endDate] = dateKey.split(",");
          return `${new Date(startDate).toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          })} - ${new Date(endDate).toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          })}`;
        } else {
          return new Date(dateKey).toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          });
        }
      });

      const viewsData = labels.map((_, index) => {
        const dateKey = Object.keys(data)[index];
        const pageviewsData = data[dateKey];

        if (Array.isArray(pageviewsData) && pageviewsData.length > 0) {
          return pageviewsData[0]?.nb_hits || 0;
        }

        if (typeof pageviewsData === "object" && pageviewsData !== null) {
          return pageviewsData?.nb_pageviews || 0;
        }

        return 0;
      });

      this.visitsChartConfig.visitsData = {
        labels,
        datasets: [
          {
            label: `${title}`,
            backgroundColor: "#00636C",
            borderColor: "#00636C",
            borderWidth: 2,
            data: viewsData,
            fill: false
          }
        ]
      };

      if (this.hasConferences && this.inquiryStatistics) {
        const conferenceInquiryData = labels.map(label => {
          if (isWeekly) {
            const [start, end] = label.split(" - ");
            const [startDay, startMonth, startYear] = start.split(".");
            const [endDay, endMonth, endYear] = end.split(".");
            const startDate = new Date(
              `${startYear}-${startMonth}-${startDay}`
            );
            const endDate = new Date(`${endYear}-${endMonth}-${endDay}`);
            let sum = 0;
            for (
              let d = new Date(startDate);
              d <= endDate;
              d.setDate(d.getDate() + 1)
            ) {
              const month = String(d.getMonth() + 1).padStart(2, "0");
              const day = String(d.getDate()).padStart(2, "0");
              const year = d.getFullYear();
              const key = `${year}-${month}-${day}`;
              sum += this.inquiryStatistics?.dates?.[key] ?? 0;
            }
            return sum;
          } else {
            const [day, month, year] = label.split(".");
            const key = `${year}-${month}-${day}`;
            return this.inquiryStatistics?.dates?.[key] ?? 0;
          }
        });

        this.visitsChartConfig.visitsData.datasets.push({
          label: "Alle Anfragen",
          backgroundColor: "#79970C",
          borderColor: "#79970C",
          borderWidth: 2,
          data: conferenceInquiryData,
          fill: false
        });
      }

      // If chart ref exists, re-render the chart
      if (this.$refs.visitsChart) {
        this.$refs.visitsChart.render();
      }
    },
    async getConferenceInquiryStatistics() {
      const headers = getTokenHeader();
      const params = {
        principal: this.currentPrincipal,
        date: `${this.fromDate},${this.toDate}`
      };
      try {
        this.fetched = false;
        const { data } = await axios.get(
          `${env.poi_api_client_url}conferenceInquiry/statistics`,
          {
            params,
            headers
          }
        );
        return data;
      } catch (err) {
        await this.$store.dispatch("createError", err);
      } finally {
        this.fetched = true;
      }
    },
    async getNewsLikesByTitle(title) {
      const params = {
        query: title.trim(),
        principal_id: this.currentPrincipal,
        limit: 1
      };
      const headers = getTokenHeader();
      const response = await axios.get(env.news_api_client_url + "news", {
        headers,
        params
      });
      const news = response.data?.[0];
      if (!news?.likes) {
        return 0;
      }

      if (this.selectedApiKey) {
        if (news.likes[this.selectedApiKey] !== undefined) {
          return news.likes[this.selectedApiKey];
        }
        return 0;
      }
      return Object.values(news.likes).reduce((sum, count) => sum + count, 0);
    }
  }
};
